import React from "react";
import { HotkeysTarget2 } from "@blueprintjs/core";


function FocusHK({setInputFocus}) {

    const hotkeys = [
        {
            combo: "f",
            global: true,
            label: "Focus",
            onKeyDown: setInputFocus,
        },
        // {
        //     combo: "cmd + e",
        //     global: true,
        //     label: "Edit",
        //     onKeyDown: handleEdit,
        // },
    ]

    return (
        <HotkeysTarget2 hotkeys={hotkeys}>
                {({ handleKeyDown, handleKeyUp }) => (
                    <div onKeyDown={handleKeyDown} onKeyUp={handleKeyUp}>
                        
                    </div>
                )}
        </HotkeysTarget2>
    )
}

export default FocusHK